import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/index'
import register from '@/page/register'
import login from '@/page/login'
import about from '@/page/about'
import service from '@/page/service'
import contact from '@/page/contact'
import newslist from '@/page/newslist'
import newspage from '@/page/newspage'
import order from '@/page/order'
import goodspage from '@/page/goodspage'
import trackpage from '@/page/trackpage'
import succful from '@/page/succful'
import forget from '@/page/forget'
import download from '@/page/download'
import report from '@/page/report'
import fyqd from '@/page/fyqd'
import kcqd from '@/page/kcqd'
import express from '@/page/express'
import gooddown from '@/page/gooddown'

Vue.use(Router)

const originalPush = Router.prototype.push
// eslint-disable-next-line
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/newslist/:id',
      name: 'newslist',
      component: newslist,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/newspage/:id',
      name: 'newspage',
      component: newspage
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/goodspage/:number/:bno',
      name: 'goodspage',
      component: goodspage
    },
    {
      path: '/trackpage/:bno?',
      name: 'trackpage',
      component: trackpage
    },
    {
      path: '/succful/',
      name: 'succful',
      component: succful
    },
    {
      path: '/forget/',
      name: 'forget',
      component: forget
    },
    {
      path: '/download/',
      name: 'download',
      component: download
    },
    {
      path: '/report/',
      name: 'report',
      component: report
    },
    {
      path: '/kcqd/',
      name: 'kcqd',
      component: kcqd
    },
    {
      path: '/fyqd/',
      name: 'fyqd',
      component: fyqd
    },
    {
      path: '/express/',
      name: 'express',
      component: express
    },
    {
      path: '/gooddown/:id/:find?',
      name: 'gooddown',
      component: gooddown
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js